// components/WechatAuth.js
import React, { useEffect } from 'react';
import { WX_APPID, WX_REDIRECT } from '../Environment';
import { xslog } from './XSLog';





export const doWechatAuth = (identity,productId,price) => {
    const appId = WX_APPID;
    let wxredi = `${WX_REDIRECT}?identity=${identity}&productId=${productId}&price=${price}`
    const redirectUri = encodeURIComponent(wxredi);

    const state = 'STATE';
    let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`;

    xslog(`doWechatAuth url ${url}`)

    window.location.href = url;

    // window.location.href = "https://www.163.com";
    // window.location.replace("https://www.163.com");
};
